import { render, staticRenderFns } from "./FormToimitusosoite.vue?vue&type=template&id=fff18eaa&scoped=true&"
import script from "./FormToimitusosoite.vue?vue&type=script&lang=js&"
export * from "./FormToimitusosoite.vue?vue&type=script&lang=js&"
import style0 from "./FormToimitusosoite.vue?vue&type=style&index=0&id=fff18eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff18eaa",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fff18eaa')) {
      api.createRecord('fff18eaa', component.options)
    } else {
      api.reload('fff18eaa', component.options)
    }
    module.hot.accept("./FormToimitusosoite.vue?vue&type=template&id=fff18eaa&scoped=true&", function () {
      api.rerender('fff18eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormToimitusosoite.vue"
export default component.exports